import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import { ScoringConfigType } from "app/pages/sales-intelligence/domain/leads/types/scoring-config";

const SCOPE_AUTOMATION_SUFFIX: Record<ScoringConfigType, string> = {
    [ScoringConfigType.User]: "add-private-rule",
    [ScoringConfigType.Account]: "add-shared-rule",
};

type ScoringAddRuleButtonProps = {
    priority: LeadPriorityScore;
    scope: ScoringConfigType;
    automationPrefix: string;
    onAddRule: (scope: ScoringConfigType) => void;
};

export const ScoringAddRuleButton = ({ priority, scope, automationPrefix, onAddRule }: ScoringAddRuleButtonProps) => {
    const { translate } = useTranslate();

    return (
        <Button
            type="primary"
            onClick={() => onAddRule(scope)}
            dataAutomation={`${automationPrefix}.column.${priority}.${SCOPE_AUTOMATION_SUFFIX[scope]}`}
        >
            {`+ ${translate("si.pages.score_settings.board.column.add_rule")}`}
        </Button>
    );
};
